module.exports = __webpack_public_path__ + "3f0a5da2626de707898a580e3cb09215.png";